import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleMenu } from "../Utils/appSlice";
import { YOUTUBE_SEARCH_API } from "../Utils/contants";
import { cacheResults } from "../Utils/searchSlice";
import { GoSearch } from "react-icons/go";
import { Link } from "react-router-dom";
import UserImage from "../Image/Ayush.png";
import { BsBell } from "react-icons/bs";
import { AiOutlineVideoCameraAdd } from "react-icons/ai";

const Head = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const searchCache = useSelector((store) => store.search);
  const dispatch = useDispatch();

  useEffect(() => {
    // API call
    const timer = setTimeout(() => {
      if (searchCache[searchQuery]) {
        setSuggestions(searchCache[searchQuery]);
      } else {
        getSearchSuggestions();
      }
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  }, [searchQuery]);

  const getSearchSuggestions = async () => {
    console.log("Api-" + searchQuery);
    const data = await fetch(YOUTUBE_SEARCH_API + searchQuery);
    const json = await data.json();
    setSuggestions(json[1]);
    console.log(json[1]);

    // Update cache
    dispatch(
      cacheResults({
        [searchQuery]: json[1],
      })
    );
  };

  const toggleMenuHandler = () => {
    dispatch(toggleMenu());
  }; // Dispatch an action

  const handleSuggestionsBlur = () => {
    // Handle the blur event for suggestions here
    setShowSuggestions(false);
  };

  return (
    <div className="grid grid-flow-col p-5 m-2">
      <div className="flex col-span-1">
        <img
          onClick={() => toggleMenuHandler()}
          className="h-8 cursor-pointer"
          alt="menu"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAARVBMVEX///8jHyAgHB0OBQgMAAWlpKQpJSaenZ309PUAAAAIAAD8/Pz5+fna2tqop6dvbW1oZmevrq4tKivFxMQYExRiYGC+vr7Dc4WrAAABB0lEQVR4nO3cS3LCMBAFQGIIIBPbhN/9jxqSyiIsTUnlydB9g1eSNV5MvdUKAAAAAAAAAAAAAAAAXtEwvscwDk3yHabSb2Loy/TRIOHUv8XRH+sHHMrSqR6U+hd1jHSE90P8lHC2/Lc0/0vzMy3WMdynxaFBwu+Jv4uh0cQHAAAAAAAAAIB59jG0ijdcT9sYTtcmK0PncumiuJRz/YD7bbf0ut4f3br+GvQt2PblrXrC3WbpUA/6sXrC/GeY/zvM/5aGmofHZiu0S//M/GoVDwAAAAAAAAAAZsjeuRerN1HL7hPy95fm76DNnzD/Lc3/0rxAJ3v+Xn0AAAAAAAAAAAAAAAD4T74AYhs1O+vt3ioAAAAASUVORK5CYII="
        />

        <Link to="/">
          <img
            className="h-8 mx-2"
            alt="youtube-logo"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/YouTube_Logo_2017.svg/2560px-YouTube_Logo_2017.svg.png"
          />
        </Link>
      </div>
      <div className="col-span-10 ">
        <div
          onBlur={handleSuggestionsBlur}
          tabIndex={0} // Make the container focusable
        >
          <div className="flex ml-10">
            <input
              className="w-[650px] border border-gray-400 h-11 p-2 rounded-l-full"
              type="text"
              placeholder="Search YouTube"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => setShowSuggestions(true)}
            />
            <Link to={"/result/?search_query=" + searchQuery}>
              <button className="py-2 px-5 h-11 rounded-r-full border border-gray-400 bg-gray-100">
                <GoSearch className="text-xl" />
              </button>
            </Link>
          </div>
          {showSuggestions && (
            <div className=" absolute w-[650px] bg-white py-2 px-2 rounded-lg mb-11 ml-10">
              <ul>
                {suggestions.map((s) => (
                  <li
                    key={s}
                    className="py-2 px-2 hover:bg-gray-100 font-semibold"
                    onMouseDown={(e) => {
                      e.preventDefault(); // Prevent default behavior
                      setSearchQuery(s); // Set the search query
                    }}

                    //onClick will not work here
                    /*  */
                  >
                    <div className="flex items-center">
                      <GoSearch className="mr-3 text-lg" /> {s}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center">
        <AiOutlineVideoCameraAdd className="text-2xl cursor-pointer" />
        <BsBell className="text-2xl ml-6 cursor-pointer" />
        <img
          className="ml-6 h-10 col-span-1 rounded-full cursor-pointer"
          alt="user"
          src={UserImage}
        />
      </div>
    </div>
  );
};

export default Head;
